import { render, staticRenderFns } from "./GraphDetail72.vue?vue&type=template&id=328366c8&scoped=true"
import script from "./GraphDetail72.vue?vue&type=script&lang=js"
export * from "./GraphDetail72.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328366c8",
  null
  
)

export default component.exports